import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import styles from './styles';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import HomeEmergencyDetails from './QueryShow/HomeEmergencyDetails';
import MotorBreakdownDetails from './QueryShow/MotorBreakdownDetails';
import ClaimDetails from './QueryShow/ClaimDetails';
import parseDate from 'date-fns/parse';
import formatDate from 'date-fns/format';
import {
  underscoreToTitleCase
} from 'utils/strings';

const parseAndFormatDate = (date, _default, format = 'DD/MM/YYYY') => {
  if (!date) {
    return _default;
  }

  return formatDate(parseDate(date), format);
};

const QueryShow = ({
  state,
  customer,
  policies,
  claims,
  error,
  classes
}) => {
  if (false === state) {
    return null;
  }

  if ('request' === state) {
    return (
      <Paper className={classNames(classes.paper, classes.centred)}>
        <CircularProgress />
      </Paper>
    )
  }

  if (('fail' === state && error) || 0 === customer.length) {
    return (
      <Paper className={classNames(classes.paper, classes.centred)}>
        Error: {error || 'No customer details found'}
      </Paper>
    )
  }

  return (
    <Paper className={classNames(classes.paper, classes.centred)}>
      <Table className={classNames(classes.table)}>
        <TableHead>
          <TableRow>
            <TableCell style={{
              width: '150px'
            }}>Policy Number</TableCell>
            <TableCell style={{
              width: '250px'
            }}>Policy</TableCell>
            <TableCell>Details</TableCell>
            <TableCell>Claims</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(policies).map(key => {
            const policy = policies[key],
              startedAt = parseAndFormatDate(policy.start),
              endedAt = parseAndFormatDate(policy.finish, 'Ongoing'),
              state = underscoreToTitleCase(policy.state)
            ;
            
            return (
              <TableRow key={policy.id}>
                <TableCell>{customer['customer-number']}-{policy.id}</TableCell>
                <TableCell>
                  Type: {policy.type}<br />
                  State: {state}<br />
                  Start Date:{startedAt}<br />
                  End Date: {endedAt}
                </TableCell>
                <TableCell>
                  {'Home Emergency' === policy.type && <HomeEmergencyDetails details={policy.details} />}
                  {'Motor Breakdown/Road Rescue' === policy.type && <MotorBreakdownDetails details={policy.details} />}
                </TableCell>
                <TableCell>
                  {policy.claims.map(id => {
                    const claim = claims[id] || {};

                    return <ClaimDetails
                      claimNumber={id}
                      state={claim.state}
                      openedAt={claim['opened-at']}
                      closedAt={claim['closed-at']}
                      outcome={claim.outcome}
                      outcomeMessage={claim['outcome-message']}
                    />
                  })}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  )
};

QueryShow.propTypes = {
  customer: PropTypes.object.isRequired,
  policies: PropTypes.objectOf(PropTypes.object).isRequired,
  claims: PropTypes.objectOf(PropTypes.object).isRequired,
  state: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ]).isRequired,
  error: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ]).isRequired,
};

export default withStyles(styles)(QueryShow);



// WEBPACK FOOTER //
// ./src/components/Query/QueryShow.js